import React from 'react';
import { PriceChangeNotification } from './PriceChangeNotification';

interface Props {
  priceChangedMessage: string | null;
}

export const CheckoutNotifications: React.FC<Props> = ({ priceChangedMessage }) => {
  return <PriceChangeNotification priceChangedMessage={priceChangedMessage} />;
};
